import { connect } from 'react-redux';
import {
  getIsAuthenticated,
  getIsRestored,
  getAuthenticator,
  getHasFailedAuth,
  getSessionData
} from 'redux-simple-auth';

const Session = ({ render, ...session }) => {
  return render(session);
}

const mapStateToProps = state => ({
  data: getSessionData(state),
  hasFailedAuth: getHasFailedAuth(state),
  authenticated: getIsAuthenticated(state) && getAuthenticator(state) === 'user',
  restored: getIsRestored(state)
})

export default connect(mapStateToProps)(Session);



// WEBPACK FOOTER //
// ./src/components/Session.js